import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  GET_LIST_ALL_SUCCESS,
  SET_LOADING_DETAILS,
  GET_DETAILS_SUCCESS,
  CLEAR_DETAILS
} from './commission-report-constants';

const INITIAL_STATE = {
  loadingData: false,
  list: {
    hasRemotePagination: false,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    orderBy: 'desc'
  },
  details: {
    loading: false,
    rows: []
  }
};

const commissionReport = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case GET_LIST_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload?.commissionReports,
          allRows: action.payload?.commissionReports,
          rowsCount: action.payload?.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_LOADING_DETAILS: {
      return {
        ...state,
        details: {
          ...state.details,
          loading: action.loading
        }
      };
    }
    case GET_DETAILS_SUCCESS: {
      return {
        ...state,
        details: {
          ...state.details,
          rows: action.payload
        }
      };
    }
    case CLEAR_DETAILS: {
      return {
        ...state,
        details: {
          ...state.details,
          rows: []
        }
      };
    }

    default:
      return state;
  }
};

export default commissionReport;
